<template>    
    <a class="back" :href="link">
        ---
        <svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.69385 2.10434L3.12671 6.69434L7.69385 11.2843L6.28781 12.6943L0.304664 6.69434L6.28781 0.694336L7.69385 2.10434Z" fill="#9597AA" fill-opacity="0.6"/>
        </svg>
        <span href="/categories">Reports</span>
    </a>
</template>

<script>
export default {
    props: ['link']
}
</script>

<style scoped lang="scss">
a.back{
    display: flex;
    color: #fff;
    text-decoration: none;
    align-items: center;
    svg{
        margin-right: .5rem;
    }
    span{

    }
}
</style>
